import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface JobRun {
  id: string;
  job: string;
  client: string | null;
  status: "success" | "failed" | "partial";
  duration_ms: number | null;
  error: string | null;
  artifact_path: string | null;
  started_at: string;
  finished_at: string | null;
}

export interface UseJobRunsOpts {
  status?: JobRun["status"];
  job?: string;
  client?: string;
  sinceHours?: number;
  limit?: number;
}

export function useJobRuns(opts: UseJobRunsOpts = {}) {
  return useQuery<JobRun[]>({
    queryKey: ["job_runs", opts],
    queryFn: async () => {
      let q = supabaseAgency.from("os_job_runs").select("*");
      if (opts.status) q = q.eq("status", opts.status);
      if (opts.job)    q = q.eq("job",    opts.job);
      if (opts.client) q = q.eq("client", opts.client);
      if (opts.sinceHours) {
        const since = new Date(Date.now() - opts.sinceHours * 3600_000).toISOString();
        q = q.gte("started_at", since);
      }
      q = q.order("started_at", { ascending: false }).limit(opts.limit ?? 100);
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []) as JobRun[];
    },
  });
}
